import { render, staticRenderFns } from "./PublishingContractsWorksEditPanelDialog.vue?vue&type=template&id=5c9f899f"
import script from "./PublishingContractsWorksEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./PublishingContractsWorksEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports